import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'
import getters from './getters'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js